import type { EventStatus } from '@/lib/types';

interface StatusDotProps {
  status: EventStatus;
  size?: number;
}

export function StatusDot({ status, size = 8 }: StatusDotProps) {
  const styles: Record<EventStatus, React.CSSProperties> = {
    upcoming: {
      width: size,
      height: size,
      borderRadius: '50%',
      border: '1.5px solid rgba(148,163,184,0.4)',
      background: 'transparent',
    },
    active: {
      width: size,
      height: size,
      borderRadius: '50%',
      background: 'var(--color-success)',
    },
    completed: {
      width: size,
      height: size,
      borderRadius: '50%',
      background: 'var(--color-success)',
      opacity: 0.6,
    },
    skipped: {
      width: size,
      height: size,
      borderRadius: '50%',
      background: 'rgba(148,163,184,0.4)',
    },
  };

  return (
    <div
      style={styles[status]}
      className={status === 'active' ? 'animate-pulse-green' : undefined}
      aria-label={`Status: ${status}`}
    />
  );
}
